import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverlastDagboek = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M20 17.81c-2.98 0-5.4-2.42-5.4-5.4s2.42-5.4 5.4-5.4 5.4 2.42 5.4 5.4-2.42 5.4-5.4 5.4m0 0c-2.98 0-5.4 2.42-5.4 5.4V33h10.81v-9.79c0-2.98-2.42-5.4-5.4-5.4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M25.9 15.92h-1c0-1.47-1.2-2.67-2.67-2.67s-2.67 1.2-2.67 2.67h-1c0-2.02 1.65-3.67 3.67-3.67s3.67 1.65 3.67 3.67M31.4 11.89l-1.7-.68-1.51.6-.38-.93 1.89-.75 1.7.68 1.7-.68 1.88.75-.37.93-1.51-.6zM34.58 8.48l-.9-.8-1.39-.02-1.04-.92-1.21-.01.01-1 1.58.01 1.05.93 1.39.01 1.17 1.05zM30.56 16.59l-.67-.74 1.15-1.05 1.38-.04 1.01-.93 1.56-.04.03 1-1.19.03-1.01.93-1.38.04z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverlastDagboek);

export default ForwardRef;
